import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      // One quiet retry covers a dropped mobile connection without hammering.
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
})
